module.exports = __webpack_public_path__ + "static/media/Remus Lupin 2.06c4b045.jpg";